export { default } from './GlobalStyles';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/styled-engine/GlobalStyles/index.js
// module id = 7440
// module chunks = 0